import React, { useEffect, useState } from 'react';

/**
 * UcMarkaGlowyticsOffer: Skechers, Brooks ve Hunter (Klaud hariç) için 3 slaytlık toplu Glowytics kullanım teklifi (Platform · Glowy Studio · Ücret), Klaud sunumunun tasarımıyla.
 * Route: /hq/uc-marka-glowytics (ProtectedRoute allowEmails, sadece sahibine açık)
 *
 * Belge iframe srcDoc içinde çalışır; kendi `@page`, `:root` ve body kuralları panele sızmasın diye.
 * HTML modülü dinamik yüklenir, ana bundle'a girmez.
 */
export default function UcMarkaGlowyticsOffer() {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    let alive = true;
    import('./ucMarkaGlowyticsHtml')
      .then((mod) => {
        if (alive) setHtml(mod.default);
      })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px">Teklif yüklenemedi.</p>');
      });
    return () => {
      alive = false;
    };
  }, []);

  const fill = { position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 0 };

  if (!html) return <div style={{ ...fill, background: '#E7E7EC' }} />;

  return <iframe title="Skechers, Brooks, Hunter · Glowytics teklif" srcDoc={html} style={fill} />;
}
